import { render, staticRenderFns } from "./Newpile.vue?vue&type=template&id=ce374da2&scoped=true&"
import script from "./Newpile.vue?vue&type=script&lang=js&"
export * from "./Newpile.vue?vue&type=script&lang=js&"
import style0 from "./Newpile.vue?vue&type=style&index=0&id=ce374da2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce374da2",
  null
  
)

export default component.exports